export enum TipoSexo {
    Indefinido = 'I',
    Masculino = 'M',
    Feminino = 'F'
}
